module.exports = __webpack_public_path__ + "static/WEDDING E&M-157-f2146784acbb3441642e3c839c719233.jpg";